<script>
import Modules from '@/components'
export default {
  name: 'Home',
  components: {
    ...Modules
  },
  data: function () {
    return {
    }
  }
}
</script>
<template>
  <div>
  <home-component></home-component>

  <about-component></about-component>

  <!-- <services-component></services-component> -->

  <contact-component></contact-component>

</div>
</template>



// WEBPACK FOOTER //
// src/Home.vue